import { ApplicationState } from '../../../../store/types';
import { MLPageData } from '../../../datasets/store/mlTypes';
import { PdfSearchResults } from '../../document-viewer/store/types';
import { getDocumentChatbotRoot } from '../../store/selectors';

export const getChatbotModalOpen = (state: ApplicationState): boolean => getDocumentChatbotRoot(state).chatbotModalOpen;
export const getChatbotLoading = (state: ApplicationState): boolean => getDocumentChatbotRoot(state).chatbotLoading;
export const getAIAnswer = (state: ApplicationState): MLPageData => getDocumentChatbotRoot(state).aiAnswer;
export const getAIResults = (state: ApplicationState): PdfSearchResults => getDocumentChatbotRoot(state).aiResults;
